// extracted by mini-css-extract-plugin
export var activeIndex = "Footer-module--activeIndex--835f5";
export var cMarginTop = "Footer-module--c-margin-top--309d0";
export var cPadding = "Footer-module--c-padding--c17bc";
export var cPaddingBottom = "Footer-module--c-padding-bottom--2f9ee";
export var cPaddingTop = "Footer-module--c-padding-top--a31b4";
export var checkbox = "Footer-module--checkbox--69061";
export var col1 = "Footer-module--col1--3f010";
export var col2 = "Footer-module--col2--e81f5";
export var col3 = "Footer-module--col3--1bd36";
export var consent = "Footer-module--consent--f3a21";
export var consentLabel = "Footer-module--consentLabel--4ed05";
export var content = "Footer-module--content--01f4c";
export var copyrightText = "Footer-module--copyrightText--23b71";
export var date = "Footer-module--date--30366";
export var disabled = "Footer-module--disabled--9a31e";
export var ellipsis = "Footer-module--ellipsis--43fd5";
export var email = "Footer-module--email--2a690";
export var featuredSection = "Footer-module--featuredSection--401d3";
export var footerContainer = "Footer-module--footerContainer--989cb";
export var footerLogo = "Footer-module--footerLogo--02690";
export var footerMenu = "Footer-module--footerMenu--95545";
export var footerPrivacy = "Footer-module--footerPrivacy--19dc6";
export var form = "Footer-module--form--a63a1";
export var formData = "Footer-module--formData--dd294";
export var formError = "Footer-module--formError--6d4dd";
export var globalSpacing = "Footer-module--global-spacing--dd73e";
export var globalSpacingBottom = "Footer-module--global-spacing-bottom--2e162";
export var globalSpacingTop = "Footer-module--global-spacing-top--19c56";
export var image = "Footer-module--image--d1e61";
export var imageWrapper = "Footer-module--imageWrapper--4d198";
export var index = "Footer-module--index--94621";
export var joinButton = "Footer-module--joinButton--089a7";
export var listItem = "Footer-module--listItem--9bff6";
export var maxWidth = "Footer-module--max-width--05f39";
export var navButton = "Footer-module--navButton--ff25d";
export var pagination = "Footer-module--pagination--ded60";
export var para = "Footer-module--para--58016";
export var paraSection = "Footer-module--paraSection--4a6e8";
export var socialIcons = "Footer-module--socialIcons--4e836";
export var styleTick = "Footer-module--styleTick--59e00";
export var subscribe = "Footer-module--subscribe--c7179";
export var tag = "Footer-module--tag--c86ae";
export var tagWrapper = "Footer-module--tagWrapper--27177";
export var title = "Footer-module--title--b71ec";